import * as axios from "~/utilities/axios"
import { PARKING_FLOW_TYPE } from "~/utilities/constants"
import { objectToString } from "~/utilities/queryParams"

export const lookup = (searchParams,urlLocation,currentHost) => {
  let flow = urlLocation.split("/")[2]
  if (flow === 'submit' || urlLocation.includes('dashboard')) flow = PARKING_FLOW_TYPE.both
  switch (flow) {
    case PARKING_FLOW_TYPE.pay:
    case PARKING_FLOW_TYPE.fight:
    case PARKING_FLOW_TYPE.both:
      searchParams.flowType = flow
  }
  searchParams.currentHost = currentHost
  return axios.secure()
    .get(`/api/v1/parking/fetcher${objectToString(searchParams)}`)
    .then(res => res.data)
    .catch(axios.parseError)
}
